module.exports = __webpack_public_path__ + "img/prescription.5a19cde8.png";